import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const SeeMoreWidget = ({ category, onClick }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
      className="
        bg-gray-800
        border border-gray-700
        rounded-3xl 
        p-6
        w-full
        aspect-square
        flex 
        flex-col
        items-center 
        justify-center
        cursor-pointer
        hover:border-gray-600
        hover:scale-105
        transition-all
        duration-200
        shadow-lg
      "
      onClick={onClick}
    >
      <div className="text-center">
        <div className="text-lg font-bold text-gray-100 mb-2">
           more 
           {/* {category} */}
        </div>
        <FontAwesomeIcon icon={faArrowRight} className="text-gray-400 text-xl" />
      </div>
    </motion.div>
  );
};

export default SeeMoreWidget;